/**
 * The text the Facebook post sheet copies: the cleaned caption, a space, and the page's tracked
 * Facebook link. The caption comes from `bodyWithoutLink`, which the middle-end already stripped of
 * every petition link, so the tracked link is the only one in the payload. The caller trims the
 * caption, because it also shows the trimmed caption as the preview.
 *
 * Returns `null` when either half is missing: an empty caption is no caption, and the sheet does not
 * copy a bare link.
 */
export function buildFacebookPostPayload(trimmedCaption: string | null, url: string | null): string | null {
	if (!trimmedCaption || !url) return null;

	return `${trimmedCaption} ${url}`;
}
